exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stack--buttons{margin-top:48px}.deck-btn--cont{min-height:40px;margin-top:-20px;display:flex;justify-content:flex-end;margin-left:auto;margin-right:auto}.icon{margin-top:3px;margin-left:5px;width:1em;height:1em;stroke-width:0;stroke:currentColor;fill:currentColor}", ""]);

// exports
